interface PersonallyIdentifiableInformationMatcher {
  // This is what we will pass into String.match()
  match: string;
  // This is what we will return in place of a matched message
  replacement: string;
}

/**
 * Set of known error message patterns
 */
export const messagePatterns: Record<
  string,
  PersonallyIdentifiableInformationMatcher
> = {
  INVALID_URL: {
    match: `Unable to open a window with invalid URL`,
    replacement: `SyntaxError: Failed to execute 'open' on 'Window': Unable to open a window with invalid URL <REDACTED_URL>`,
  },
};

export const scrubMessage = (message: string) => {
  let msg = message;
  for (const value of Object.values(messagePatterns)) {
    const { match, replacement } = value;
    if (message.match(match)) {
      msg = replacement;
    }
  }

  return msg;
};
